<template>
  <el-dialog
    :visible.sync="pointDialog"
    :close-on-click-modal="false"
    @close="closePointDialog"
    :title="dialogTitle"
    v-dialogDrag
    class="small-dialog"
  >
    <div v-if="pointDialog" v-loading="dialogLoading">
      <el-form
        :model="pointForm"
        :rules="pointRules"
        ref="pointForm"
        :disabled="dialogType === 'show'"
        label-width="150px"
        size="small"
      >
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item :label="$t('测点编码')" prop="code">
              <el-input
                :placeholder="$t('请填写测点编码')"
                v-model="pointForm.code"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('测点名称')" prop="name">
              <el-input
                :placeholder="$t('请填写测点名称')"
                v-model="pointForm.name"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item :label="$t('单位')" prop="unit">
              <el-input
                :placeholder="$t('请填写单位')"
                v-model="pointForm.unit"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('测点周期')" prop="cycle">
              <el-input :placeholder="$t('请填写测点周期')" v-model="pointForm.cycle" clearable>
                <template slot="append">ms</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item :label="$t('测点类型')" prop="type">
              <el-select filterable class="w-full" v-model="pointForm.type" clearable>
                <el-option
                  v-for="item in pointType"
                  :label="item.name"
                  :value="item.value"
                  :key="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('测点驱动')" prop="driveName">
              <el-select filterable class="w-full" v-model="pointForm.driveName" clearable>
                <el-option
                  v-for="item in driveOptions"
                  :value="item.id"
                  :label="item.name"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" v-if="pointForm.type === 2 || pointForm.type === 3">
          <el-col :span="24">
            <el-form-item :label="$t('表达式')" prop="expression">
              <el-input
                type="textarea"
                :rows="3"
                :placeholder="$t('请填写表达式')"
                v-model="pointForm.expression"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item :label="$t('量程上限')" prop="upperLimit">
              <el-input-number
                :controls="false"
                :placeholder="$t('请填写量程上限')"
                v-model="pointForm.upperLimit"
                clearable
                class="w-440px"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('量程下限')" prop="lowerLimit">
              <el-input-number
                :controls="false"
                :placeholder="$t('请填写量程下限')"
                v-model="pointForm.lowerLimit"
                clearable
                class="w-440px"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24" v-if="dialogTitle !== '新增测点'">
            <el-form-item :label="$t('测点序号')" prop="pointId">
              <el-input
                readonly
                :placeholder="$t('请填写测点序号')"
                v-model="pointForm.pointId"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="showPointDetail">
            <el-form-item :label="$t('专业')" prop="disciplineId">
              <el-select
                v-model="pointForm.disciplineId"
                class="mt-5px w-full"
                :placeholder="$t('请选择专业')"
                size="small"
                clearable
              >
                <el-option
                  v-for="el in professionsList"
                  :key="el.id"
                  :label="el.name"
                  :value="el.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="showPointDetail && dialogTitle === '新增测点'">
            <el-form-item :label="$t('机组')" prop="plantUnitId">
              <el-select
                v-model="pointForm.plantUnitId"
                class="mt-5px w-full"
                :placeholder="$t('请选择机组')"
                size="small"
                clearable
                filterable
              >
                <el-option v-for="el in unitList" :key="el.id" :label="el.name" :value="el.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" v-if="showPointDetail && dialogTitle !== '新增测点'">
          <el-col :span="24">
            <el-form-item :label="$t('机组')" prop="plantUnitId">
              <el-select
                v-model="pointForm.plantUnitId"
                class="mt-5px w-full"
                :placeholder="$t('请选择机组')"
                size="small"
                clearable
                filterable
              >
                <el-option v-for="el in unitList" :key="el.id" :label="el.name" :value="el.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div v-if="dialogType !== 'show'" class="tc dialog-footer" slot="footer">
      <el-button
        size="small"
        type="default"
        class="iconfont icon-close"
        @click="pointDialog = false"
        >{{ $t('cancel') }}</el-button
      >
      <el-button
        size="small"
        type="primary"
        class="iconfont icon-save"
        @click="submitData()"
        :loading="submitLoading"
        >{{ $t('save') }}</el-button
      >
      <!-- <el-button type="primary" @click="submitData" :loading="submitLoading">保存</el-button>
      <el-button @click="resetPointForm">重置</el-button> -->
    </div>
  </el-dialog>
</template>

<script type="text/babel">
import TargetManagementService from '@/services/DatatargetManagement'
import ApiMixinPoint from '@/assets/js/api/measuringPoint'
import ApiMixinDictionaryManagement from '@/assets/js/api/dictionaryManagement'
import PointService from '@/services/MeasuringPoint'

export default {
  mixins: [ApiMixinPoint, ApiMixinDictionaryManagement],
  components: {},
  props: ['standardId'],
  data() {
    return {
      pointDialog: false,
      dialogTitle: '新增测点',
      dialogLoading: false,
      submitLoading: false,
      pointRules: {
        code: [{ required: true, trigger: 'blur' }],
        name: [{ required: true, message: '请填写测点名称', trigger: 'blur' }],
        cycle: [{ trigger: 'blur' }],
        type: [{ required: true, message: '请选择测点类型', trigger: 'change' }],
        plantUnitId: [{ required: true, message: '请选择机组', trigger: 'blur' }],
      },
      dialogType: 'add',
      pointForm: {
        code: null,
        name: null,
        unit: null,
        cycle: null,
        type: null,
        driveName: null,
        expression: null,
        upperLimit: null,
        lowerLimit: null,
        pointId: null,
        plantUnitId: '',
        disciplineId: '',
      },
      pointType: [
        { value: 1, name: '模拟量' },
        { value: 2, name: '开关量' },
        // { value: 3, name: '逻辑模拟量PI' },
      ],
      driveOptions: [],
      unitList: [], // 机组
      professionsList: [], // 所属专业
      currentEnv: Wiz.GetModuleConfig('legacy-resource').currentEnv,
    }
  },
  computed: {
    currentProject() {
      return this.$store.getters['Sites/currentProject'] || {}
    },
    showPointDetail() {
      return this.currentEnv.VUE_APP_SHOW_POINT_DETAIL === 'true'
    },
  },
  watch: {},
  methods: {
    // 专业
    async getProfessions() {
      const { code, data } = await TargetManagementService.apiProfessions()
      if (code === 0 && !_.isEmpty(data)) {
        this.professionsList = data
      }
    },
    // 机组
    async getUnit() {
      const { code, data } = await TargetManagementService.apiUnit()
      if (code === 0 && !_.isEmpty(data)) {
        this.unitList = data
      }
    },
    // 获取测点类型
    async getDicData() {
      this.driveOptions = []
      const res = await this.apiDictionary({
        method: 'query',
        params: {
          where: { typeName: '测点驱动' },
          dataPage: { pageSize: 1000, pageNo: 1 },
        },
      })
      if (res && res.success && res.dataList && res.dataList.length) {
        this.driveOptions = res.dataList
      }
    },
    // 关闭模态框
    closePointDialog() {
      this.pointDialog = false
      this.submitLoading = false
      this.dialogLoading = false
      this.dialogType = 'add'
      this.dialogTitle = '新增测点'
      this.resetFormData()
    },
    // 重置
    async resetPointForm() {
      console.log('点击重置', this.dialogType)
      if (this.dialogType === 'add') {
        _.assign(this.pointForm, {
          code: null,
          name: null,
          unit: null,
          cycle: null,
          type: null,
          driveName: null,
          expression: null,
          upperLimit: null,
          lowerLimit: null,
          pointId: null,
        })
        this.$refs.pointForm.clearValidate()
      } else if (this.dialogType === 'edit') {
        const res = await this.apiPoint({
          method: 'detail',
          params: { id: this.pointForm.id },
        })
        this.dialogLoading = false
        if (res && res.code === 0 && res.data) {
          _.assign(this.pointForm, res.data)
          if (this.pointForm.cycle < 0) {
            this.pointForm.cycle = ''
          }
          if (this.pointForm.type < 0) {
            this.pointForm.type = null
          }
        }
      }
    },
    // 打开模态框
    async openPointDialog(type, data, pointType) {
      this.dialogType = type
      this.pointDialog = true
      if (data) {
        this.dialogTitle = type === 'edit' ? '编辑测点' : '测点详情'
        if (pointType === 'id') {
          this.getDetailById(data.id)
        } else {
          this.getDetailByPointId(data.pointId)
        }
      } else {
        this.dialogTitle = '新增测点'
        this.resetFormData()
      }
    },
    async getDetailById(id) {
      this.dialogLoading = true
      const res = await this.apiPoint({
        method: 'detail',
        params: { id },
      })
      this.dialogLoading = false
      if (res && res.code === 0 && res.data) {
        _.assign(this.pointForm, res.data)
        this.pointForm = res.data
        const drive = _.find(this.driveOptions, { name: res.data.driveName })
        this.pointForm.driveName = drive ? drive.id : ''
        if (this.pointForm.cycle < 0) {
          this.pointForm.cycle = ''
        }
        if (this.pointForm.type < 0) {
          this.pointForm.type = null
        }
      }
    },
    async getDetailByPointId(id) {
      this.dialogLoading = true
      const res = await PointService.findPointDetail({
        pointId: id,
      })
      this.dialogLoading = false
      if (res && res.code === 0 && !_.isNil(res.data)) {
        this.pointForm = res.data
        this.pointForm.driveName = res.data.drive
        if (this.pointForm.cycle < 0) {
          this.pointForm.cycle = ''
        }
        if (this.pointForm.type < 0) {
          this.pointForm.type = null
        }
      }
    },
    // 表单数据恢复原始
    resetFormData() {
      this.pointForm = {
        code: null,
        name: null,
        unit: null,
        cycle: null,
        type: null,
        driveName: null,
        expression: null,
        upperLimit: null,
        lowerLimit: null,
        pointId: null,
      }
    },
    // 提交数据
    submitData() {
      this.$refs.pointForm.validate(async (valid) => {
        if (valid) {
          this.submitLoading = true
          const params = {}
          _.assign(params, this.pointForm)
          params.standardId = this.standardId
          params.siteCode = this.currentProject.name
          params.cycle = params.cycle ? _.toNumber(params.cycle) : -1
          params.drive = params.driveName
          delete params.driveName
          if (!params.id) {
            delete params.pointId
          }
          const res = await this.apiPoint({
            method: params.id ? 'edit' : 'add',
            params,
          })
          this.submitLoading = false
          if (res && res.code === 0 && res.data) {
            this.$message.success('保存成功')
            this.$emit('submit')
            this.pointDialog = false
          } else if (res.msg === `${this.pointForm.code}：已存在`) {
            this.$message.warning(res.msg)
          }
        }
      })
    },
  },
  created() {
    this.pointRules.code[0].validator = (rule, value, callback) => {
      // const codeReg = /[\u4E00-\u9FA5]/g
      if (!value) {
        callback(this.$message.warning('请输入测点编码'))
        // } else if (codeReg.test(value)) {
        //   callback(this.$message.warning('测点编码不能含有汉字'))
      } else {
        callback()
      }
    }
    this.pointRules.cycle[0].validator = (rule, value, callback) => {
      const flag =
        _.toString(value)
          .split('.')[0]
          .substring(0, 1) === '0' && _.toString(value).split('.')[0].length > 1
      const check = _.toNumber(value)
      if (value && (!_.isNumber(check) || _.isNaN(check) || flag || check <= 0)) {
        callback(new Error('请输入大于0的有效数字'))
      } else {
        callback()
      }
    }
    this.getDicData()
    // this.getUnit() // 获取机组
    // this.getProfessions() // 获取专业
  },
  mounted() {},
}
</script>

<style scoped lang="scss">

/deep/.el-input-number.is-without-controls .el-input__inner {
  text-align: left;
}

</style>
